import React from "react";
import { Form } from "react-bootstrap";



function ListSelector(props) {

  function handleItemChange(event) {
    props.onChange( event.target.value );
  }


  return (
    <Form.Control as="select" value={props.value} onChange={handleItemChange}>
      {props.items.map( i => <option value={i.value}>{i.desc}</option> ) }
    </Form.Control>
  );

}


export default ListSelector;

